import { CRIME_RISK_ZOOM_DETAILS as i, CRIME_RISK_STATIC_BINS as o } from "./index.es467.js";
import { DAYTIME_POP_DENSITY_STATIC_COUNTY_BINS as c, DAYTIME_POP_DENSITY_STATIC_ZIPCODE_BINS as g, DAYTIME_POP_DENSITY_STATIC_CBG_BINS as l } from "./index.es468.js";
import { ETHNICITY_BINS as s } from "./index.es469.js";
import { HOUSE_DENSITY_STATIC_BINS as r } from "./index.es470.js";
import { MEDIAN_AGE_BINS as p } from "./index.es471.js";
import { HOUSE_VALUE_STATIC_BINS as n } from "./index.es472.js";
import "./index.es473.js";
import { MOSAIC_BINS as d } from "./index.es91.js";
import { PERSONA_LIVE_BINS as y } from "./index.es92.js";
import { POP_DENSITY_STATIC_COUNTY_BINS as u, POP_DENSITY_STATIC_ZIPCODE_BINS as m, POP_DENSITY_STATIC_CBG_BINS as T } from "./index.es474.js";
import { POP_DOT_DENSITY_STATIC_COUNTY_BINS as _, POP_DOT_DENSITY_STATIC_ZIPCODE_BINS as h, POP_DOT_DENSITY_STATIC_CBG_BINS as S } from "./index.es475.js";
import { POP_GROWTH_2023_2028_STATIC_BINS as t, POP_GROWTH_2021_2023_STATIC_BINS as a } from "./index.es476.js";
import { DEFAULT_ZOOM_DETAILS as e } from "./index.es477.js";
import "./index.es478.js";
const E = {
  bachelorsDegreeAndHigher: {
    id: "bachelorsDegreeAndHigher",
    name: "Bachelors Degree and Higher",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "edu_popstats_2022",
    tileCategory: "demographics",
    propertyKey: "Bach_p",
    legendRangeType: "Percentile",
    legendDescPrefix: "% of Population, ",
    bucketingMode: "dynamic",
    dynamicBucketingConfig: {
      paletteKey: "Purple"
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  daytimePopulationDensity: {
    id: "daytimePopulationDensity",
    name: "Daytime Population",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Workplace (2024)",
    tileSource: "daytimepop_workplace_2024",
    tileCategory: "demographics",
    propertyKey: "DTpop_density",
    propertyUnit: "",
    propertyValueScale: 1,
    labelRounding: 1,
    legendRangeType: "Numeric",
    legendDescPrefix: "Population per sq. mile, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: l,
      zipcode: g,
      county: c,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  housingDensity: {
    id: "housingDensity",
    name: "Housing Unit Density",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "housingdensity_popstats_2023",
    tileCategory: "demographics",
    propertyKey: "HouseDens",
    labelRounding: 1,
    legendRangeType: "Numeric",
    legendDescPrefix: "Units per sq. Mile, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: r,
      zipcode: r,
      county: r,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  maidenAge: {
    id: "maidenAge",
    name: "Median Age",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "age_popstats_2022",
    tileCategory: "demographics",
    propertyKey: "median_age",
    legendRangeType: "Numeric",
    legendDescPrefix: "Years, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: p,
      zipcode: p,
      county: p,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  medianHouseValue: {
    id: "medianHouseValue",
    name: "Median House Value",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "housevalue_popstats_2023",
    tileCategory: "demographics",
    propertyKey: "median_hv",
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: n,
      zipcode: n,
      county: n,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  medianHouseholdIncome: {
    id: "medianHouseholdIncome",
    name: "Median Household Income",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "Popstats, 2022",
    tileSource: "hhi_popstats_2022",
    tileCategory: "demographics",
    propertyKey: "median_hhi",
    legendRangeType: "Income",
    legendDescPrefix: "",
    bucketingMode: "dynamic",
    dynamicBucketingConfig: {
      paletteKey: "Yellow Green"
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  populationDensity: {
    id: "populationDensity",
    name: "Population Density",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "Popstats, 2022",
    tileSource: "pop_popstats_2022",
    tileCategory: "demographics",
    propertyKey: "pop_density",
    labelRounding: 1,
    legendRangeType: "Numeric",
    legendDescPrefix: "Population per sq. mile, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: T,
      zipcode: m,
      county: u,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  populationDotDensity: {
    id: "populationDotDensity",
    name: "Population Dot Density",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "popdot_popstats_2023",
    tileCategory: "demographics",
    propertyKey: "population",
    legendRangeType: "Numeric",
    legendDescPrefix: "Population per sq. mile, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: S,
      zipcode: h,
      county: _,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "dot"
  },
  personaLive: {
    id: "personaLive",
    name: "Predominant PersonaLive Families",
    disabledText: "Contact your customer success manager to gain access to this dataset",
    layerCategory: "Psychographics",
    dataSource: "Spatial.ai, 2023",
    tileSource: "personalive_spatialai_2023",
    tileCategory: "demographics",
    propertyKey: "domCat",
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "categorical",
    categoricalBucketingConfig: y,
    zoomDetails: e,
    vizType: "choropleth"
  },
  mosaic: {
    id: "mosaic",
    name: "Predominant Mosaic Segment (Groups)",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "domCat",
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "categorical",
    categoricalBucketingConfig: d,
    zoomDetails: e,
    vizType: "choropleth"
  },
  populationGrowth20212023: {
    id: "populationGrowth20212023",
    name: "Population Growth 2021-2023",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "popgrowth_popstats_2023",
    tileCategory: "demographics",
    propertyKey: "21_23_pchange",
    propertyUnit: "%",
    propertyValueScale: 1,
    labelRounding: 1,
    legendRangeType: "Percentile",
    legendDescPrefix: "% of People, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: a,
      zipcode: a,
      county: a,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  populationGrowth20232028: {
    id: "populationGrowth20232028",
    name: "Population Growth 2023-2028",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "popgrowth_popstats_2023",
    tileCategory: "demographics",
    propertyKey: "23_28_pchange",
    propertyUnit: "%",
    propertyValueScale: 1,
    labelRounding: 1,
    legendRangeType: "Percentile",
    legendDescPrefix: "% of People, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: t,
      zipcode: t,
      county: t,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  populationGrowth20222024: {
    id: "populationGrowth20222024",
    name: "Population Growth 2022-2024",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2024)",
    tileSource: "popgrowth_popstats_2024",
    tileCategory: "demographics",
    propertyKey: "22_24_pchange",
    propertyUnit: "%",
    propertyValueScale: 1,
    labelRounding: 1,
    legendRangeType: "Percentile",
    legendDescPrefix: "% of People, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: a,
      zipcode: a,
      county: a,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  populationGrowth20242029: {
    id: "populationGrowth20242029",
    name: "Population Growth 2024-2029",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2024)",
    tileSource: "popgrowth_popstats_2024",
    tileCategory: "demographics",
    propertyKey: "24_29_pchange",
    propertyUnit: "%",
    propertyValueScale: 1,
    labelRounding: 1,
    legendRangeType: "Percentile",
    legendDescPrefix: "% of People, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: t,
      zipcode: t,
      county: t,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  ethnicity: {
    id: "ethnicity",
    name: "Predominant Ethnicity",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "Census (ACS) 2022",
    tileSource: "eth_census_2022",
    tileCategory: "demographics",
    propertyKey: "domCat",
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "categorical",
    categoricalBucketingConfig: s,
    zoomDetails: e,
    vizType: "choropleth"
  },
  totalCrime: {
    id: "totalCrime",
    name: "Total Crime Index",
    disabledText: "",
    layerCategory: "Crime Risks",
    dataSource: "AGS, 2024",
    tileSource: "crimerisk_ags_2024",
    tileCategory: "demographics",
    propertyKey: "CRMCYTOTC",
    propertyUnit: "",
    propertyValueScale: 1,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: o,
      zipcode: o,
      county: o,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  totalPersonalCrime: {
    id: "totalPersonalCrime",
    name: "Total Personal Crime Index",
    disabledText: "",
    layerCategory: "Crime Risks",
    dataSource: "AGS, 2024",
    tileSource: "crimerisk_ags_2024",
    tileCategory: "demographics",
    propertyKey: "CRMCYPERC",
    propertyUnit: "",
    propertyValueScale: 1,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: o,
      zipcode: o,
      county: o,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  totalPropertyCrime: {
    id: "totalPropertyCrime",
    name: "Total Property Crime Index",
    disabledText: "",
    layerCategory: "Crime Risks",
    dataSource: "AGS, 2024",
    tileSource: "crimerisk_ags_2024",
    tileCategory: "demographics",
    propertyKey: "CRMCYPROC",
    propertyUnit: "",
    propertyValueScale: 1,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: o,
      zipcode: o,
      county: o,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  }
};
export {
  E as DEFAULT_LAYER_INFO
};
//# sourceMappingURL=index.es295.js.map
